var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-table",
    { attrs: { data: _vm.billsList } },
    [
      _c("el-table-column", {
        attrs: { label: "NÚMERO DE FACTURA", prop: "billNum" },
      }),
      _c("el-table-column", {
        attrs: { label: "PSEUDO FACTURA", prop: "pseudoBillNum" },
      }),
      _c("el-table-column", {
        attrs: { label: "CUPS", prop: "cups" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("Core-CupsColumn", {
                  attrs: { cups: scope.row.cups, index: scope.$index },
                }),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "TIPO DE FACTURA", prop: "billTypeCode" },
      }),
      _c("el-table-column", {
        attrs: { label: "TIPO DE PROCESO", prop: "processCode" },
      }),
      _c("el-table-column", {
        attrs: { label: "FECHA FACTURACIÓN", prop: "billDate" },
      }),
      _c("el-table-column", {
        attrs: { label: "FECHA PROCESO", prop: "createdAt" },
      }),
      _c("el-table-column", { attrs: { label: "IMPORTE", prop: "amount" } }),
      _c("el-table-column", {
        attrs: {
          label: "COMERCIALIZADORA",
          prop: "marketerCode",
          width: "200",
        },
      }),
      _c("el-table-column", {
        attrs: { width: "175", fixed: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onClickDownload(scope.row.id)
                          },
                        },
                      },
                      [
                        _vm._v("Descargar"),
                        _c("i", { staticClass: "el-icon-download" }),
                      ]
                    ),
                    _c("span"),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }